/* eslint-disable */
import i18n from '@/plugins/i18n';

const origemContasAPagar = [
  { text: 'Flowinvest', value: 'TED_FLOW_INVEST' },
  { text: 'MoneyPlus', value: 'TED_MONEY_PLUS' },
];

const statusContasAPagar = ['PENDENTE', 'BAIXADA'];

const statusCobrancasSgv = [
  {
    text: i18n.t('app.financial.chargePayment.filter.effective'),
    value: 'EFETIVADO',
  },
  {
    text: i18n.t('app.financial.chargePayment.filter.rejected'),
    value: 'REJEITADO',
  },
  {
    text: i18n.t('app.financial.chargePayment.filter.paymentError'),
    value: 'ERRO_NO_PAGAMENTO',
  },
  {
    text: i18n.t('app.financial.chargePayment.filter.terminated'),
    value: 'BAIXADA',
  },
];

export {
  origemContasAPagar,
  statusContasAPagar,
  statusCobrancasSgv,
};
